export interface Property {
  _id: string;
  propertyID: string;
  projectDetails: ProjectDetails;
  itemType: string;
  propertyType: string;
  propertyName: string;
  propertyFeatured: string;
  propertyKey: string;
  propertyPurpose: string;
  cityID: string;
  cityLocationID: string;
  cityLocName: string;
  propertyCurrentStatus: string;
  propertyAddedDate: string;
  propertyUpdateDate: string;
  propertyDescription: string;
  furnishingStatus: string;
  propertyTypeName: string;
  propertyTypeID: string;
  isNegotiable: string;
  priceOnReq: string;
  proLatitude: number;
  proLongitude: number;
  possessionDate: string;
  isOffer: string;
  propertyOfferStartTime: string;
  propertyOfferEndTime: string;
  propertyOfferDiscount: string;
  propertySoldOutStatus: string;
  propertySoldOutPrice: string;
  propertySoldOutDate: string;
  openhouseStatus: string;
  propertyPrice: string;
  propertyPriceMap: string;
  currencySymbolLeft: string;
  currencySymbolRight: string;
  propertyFavourite: string;
  propertyCoverImage: string;
  propertyBedRoom: string;
  propertySqrFeet: string;
  propertyPlotArea: string;
  planPropertyDetails: string;
  planEnquiry: string;
  planEnquiryCount: string;
  planEnquiryCountBalance: string;
  userTypeID: string;
  userID: string;
  type: string;
  properyPriceType: string;
  numberOfSeats: string;
  publicDisplay: string;
  currencyID_6: string;
  propertyPrices: any;
  pricesPerSqfts: any;
  pricePerSqft: string;
  rentUnitCount: number;
  sellUnitCount: number;
  link: string;
  attributes: IAttribute[];
  attrName: string;
  attrDetValue: string;
  propImageCat: any[];
  imageCatID: string;
  imageCatName: string;
  imgCount: string;
  propCoverImage: string;
  propertyStatus: string;
  propertyMetaTitle: string;
  propertyMetaKeyword: string;
  propertyAvailableStatus: string;
  availablefromdate: string;
  planExpiryDate: string;
  propertyAddress1: string;
  propertyAddress2: string;
  propertyLatitude: string;
  propertyLongitude: string;
  cityLocID: string;
  countryName: string;
  stateName: string;
  cityName: string;
  countryID: string;
  userFirstname: string;
  userLastName: string;
  userCompanyName: string;
  userPhone: string;
  propertyTypeKey: string;
  userAlternatePhone: string;
  userCountryCode: string;
  userEmail: string;
  userUrlKey: string;
  planID: string;
  premiumEndDate: string;
  userPlanID: string;
  expiryStatus: string;
  dateDiff: string;
  propertyBuiltUpArea: string;
  propertyBathRoom: string;
  availableUnits: string;
  plotareaUnit: string;
  areaType: string;
  propFurnishingStatus: string;
  propSaleStatus: string;
  floorOffered: string;
  floorsStructure: string;
  timeline: string;
  unitNumber: string;
  interior: string;
  cityLocKey: string;
  propertyplanEnquiryCountBalance: string;
  amenities?: any[];
  attribute?: any;
  contactDetails?: any[];
  // unitDetails?: Unit[];
  cityLocation?: any;
  city?: any;
  propertyFloorImage?: string;
  unitDetails?: any;
}

export interface IAttribute {
  attrGroupName: string;
  attrID: number;
  attrKey: string;
  attrName: string;
  attrOptionValue: string;
}

export interface ProjectDetails {
  projectName: string;
  projectCurrentStatus: string;
  projectAddedDate: Date;
  projectDescription: string;
  projectBuilderName: { [key: string]: string };
  projectTypeName: string;
  projectCoverImage?: string;
}

export enum ConstructionStatus {
  Upcoming = "upcoming",
  ReadyToMove = "readyToMove",
  UnderConstruction = "underConstruction",
  Operational = "operational",
  ContactForAvailaibility = "contactForAvailability",
  LeasedOut = "leasedOut",
  SoldOut = "soldOut",
  NotAvailable = "notAvailaible",
}

export enum PropertyFeatured {
  ON = "ON",
  OFF = "OFF",
}

export enum PropertyPurpose {
  Sell = "Sell",
  Rent = "Rent",
}

export enum propertyCurrentStatus {
  Ready_for_fit_outs = "Ready for fit outs",
  Ready_to_move = "Ready to move",
  Upcoming = "Upcoming",
  Under_Construction = "Under Construction",
}

export enum FurnishingStatus {
  Pre_Furnished = "Pre Furnished",
  Semi_Furnished = "Semi Furnished",
  Warm_Shell = "Warm Shell",
  Bare_Shell = "Bare Shell",
}

export enum SoldOutStatus {
  Yes = "Yes",
  No = "No",
}

export const FurnishingHeadAttributeKeys = [
  "reception-area",
  "work-stations",
  "no-of-cubicles",
  "cabins",
  "meeting-rooms",
  "discussion-rooms",
  "conference-rooms",
  "pantry",
  "cafeteria",
  "electrical-room",
  "ups-room",
  "hub-room",
  "lab-area",
  "server-room",
  "store-rooms",
  "training-rooms",
  "toilets",
  "others",
];
